@include component-spacing-and-grid;

:host {
    display: block;
    background-color: $color-grey-06-bright;

    .main-content-container {
        display: block;
        grid-template-columns: repeat(12, 1fr);
        column-gap: var(--column-gap);
        padding: 60px 0 80px;
    }

    h2 {
        @include typo-ws-h2;

        grid-column: 1 / span 12;
        margin: 0;
    }

    ::slotted(sew-ws-richtext) {
        margin-top: 24px;
        grid-column: 1 / span 6;
    }

    .items {
        grid-column: 1 / span 12;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        margin-top: 40px;
    }
}

@include mq-2 {
    :host {
        .main-content-container {
            padding: 60px 0;
        }

        ::slotted(sew-ws-richtext) {
            grid-column: 1 / span 12;
        }

        .items {
            column-gap: var(--column-gap);
            row-gap: 24px;
        }
    }
}

@include mq-1 {
    :host {
        .main-content-container {
            padding: 32px 0 40px;
        }

        .items {
            margin-top: 32px;
            grid-template-columns: repeat(2, 1fr);
            row-gap: var(--column-gap);
        }
    }
}
